<template>
  <li :class="'simulation-list-item' + setActiveClass()" role="presentation">
    <button class="simulation-button" @click="setActiveScenario"
      :aria-selected="isScenarioActive().toString()"
      :aria-controls="isScenarioActive() ? `scenario-box` : null"
      :aria-describedby="isScenarioActive() ? `simulation-card-${scenarioId}` : null"
      role="tab"
      >{{ setFormatAmount() }}</button>
  </li>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { NumberFormatterClass } from '../../class/calculator.class'
import { DateClass } from '../../class/date.class'
import { CALCULATOR_CONTENT } from '../../const/calculator.const'

export default {
  name: 'SimulationBox',
  props: ['simulation'],
  data () {
    return {
      scenarioId: this.simulation.id,
      amount: this.simulation.amount,
      dayPercent: this.simulation.dayPercent,
      maxAmount: CALCULATOR_CONTENT.amount.max,
      percent: CALCULATOR_CONTENT.amount.percent,
      costAmount: null,
      barBoxHeight: null,
      repaymentTerm: CALCULATOR_CONTENT.dates.startRepaymentTerm,
      repaymentMaxTerm: CALCULATOR_CONTENT.dates.startRepaymentMaxTerm
    }
  },
  computed: {
    ...mapState({
      activeScenario: state => state.scenarios.scenario
    })
  },
  methods: {
    ...mapMutations([
      'SET_SCENARIO_ACTIVE',
      'SET_SCENARIO_AMOUNT',
      'SET_SCENARIO_PERCENT'
    ]),
    setActiveScenario () {
      this.SET_SCENARIO_AMOUNT(this.amount)
      this.SET_SCENARIO_ACTIVE(this.scenarioId)
      this.SET_SCENARIO_PERCENT(this.dayPercent)
      if (window.innerWidth < 992) {
        this.goToScenario()
      }
    },
    isScenarioActive () {
      return this.activeScenario === this.scenarioId
    },
    goToScenario () {
      const top = this.$parent.$el.nextSibling.offsetTop
      window.scrollTo(0, top)
    },
    setActiveClass () {
      return this.activeScenario === this.scenarioId ? ' activeScenario' : ''
    },
    setRepaymentDateShorter () {
      return DateClass.setYear(1)
    },
    setFormatAmount () {
      return NumberFormatterClass.formatAmount(this.amount)
    },
    setScenarioData () {
      this.activeScenario === this.scenarioId && this.SET_SCENARIO_PERCENT(this.dayPercent)
      this.activeScenario === this.scenarioId && this.SET_SCENARIO_AMOUNT(this.amount)
    }
  },
  mounted () {
    this.setScenarioData()
  }
}
</script>
